import { useEffect, useRef } from "react";

/** Keyboard (↑/↓, j/k, m), wheel and touch-swipe navigation for vertical feeds. */
export const useVerticalNav = ({ next, prev, onMuteKey }) => {
  const touchStartY = useRef(null);
  const wheelLock = useRef(0);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowDown" || e.key === "PageDown" || e.key === "j") { e.preventDefault(); next(); }
      else if (e.key === "ArrowUp" || e.key === "PageUp" || e.key === "k") { e.preventDefault(); prev(); }
      else if (e.key === "m") onMuteKey();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [next, prev, onMuteKey]);

  const onWheel = (e) => {
    const now = Date.now();
    if (now - wheelLock.current < 550 || Math.abs(e.deltaY) < 8) return;
    wheelLock.current = now;
    if (e.deltaY > 0) next(); else prev();
  };
  const onTouchStart = (e) => { touchStartY.current = e.touches[0].clientY; };
  const onTouchEnd = (e) => {
    if (touchStartY.current == null) return;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    if (dy < -55) next();
    else if (dy > 55) prev();
    touchStartY.current = null;
  };

  return { onWheel, onTouchStart, onTouchEnd };
};
